import React from 'react';
import { func } from 'prop-types';
import Panel from 'components/Panel/Panel';
import {
  StyledRow,
  PackageInfo,
  PackageUsage,
  StyledRowItem,
  StyledWrapper,
  PackageWrapper,
} from 'components/Settings/Settings.styled';
import { capitalizeFirstLetter } from 'utils/';
import { LinkButton } from 'components/Buttons/';
import { ORDER, INVENTORY } from 'constants/inventory';
import { ReactComponent as ActivityIcon } from 'icons/activity.svg';
import { ReactComponent as PackageIcon } from 'icons/package_circle.svg';
import { ReactComponent as BillingIcon } from 'icons/billing_circle.svg';
import { ReactComponent as SettingsIcon } from 'icons/settings_circle.svg';
import { ORDER_SETTING, EMAIL_NOTIFICATION_SETTING } from 'constants/modal';
import { ReactComponent as InventoryIcon } from 'icons/inventory_large.svg';
import { ReactComponent as WarehouseIcon } from 'icons/warehouse_circle.svg';

/**
 * @param {{
 * storageCount : Object,
 * inventoryCount : Object,
 * packageDetails : Object,
 * onShowTagModal : Function
 * onShowCompanyModal : Function
 * onShowCategoryModal : Function
 * onShowAddStorageModal : Function
 * onShowViewStorageModal : Function
 * onShowIntegrationModal : Function
 * onShowAddWarehouseModal : Function
 * onShowViewWarehouseModal : Function
 * }} param
 */
export function Settings({
  storageCount,
  inventoryCount,
  onShowTagModal,
  packageDetails,
  onShowSettingModal,
  onShowCompanyModal,
  onShowCategoryModal,
  onShowAddStorageModal,
  onShowViewStorageModal,
  onShowIntegrationModal,
  onShowAddWarehouseModal,
  onShowViewWarehouseModal,
}) {
  const minPanelHeight = 100;
  const { storages, warehouses } = storageCount;
  const { users, assets, inventory } = inventoryCount;

  return (
    <StyledWrapper>
      <StyledRow>
        <StyledRowItem>
          <Panel
            icon={<SettingsIcon />}
            header="Company Settings"
            minHeight={minPanelHeight}
          >
            <LinkButton
              onClick={onShowCompanyModal}
              caption="View and Edit Profile"
            />
            <LinkButton
              caption="Integrations"
              onClick={onShowIntegrationModal}
            />
          </Panel>
        </StyledRowItem>
        <StyledRowItem>
          <Panel
            header="Warehouses"
            icon={<WarehouseIcon />}
            minHeight={minPanelHeight}
          >
            <LinkButton onClick={onShowAddWarehouseModal} caption="Add New" />
            <LinkButton
              caption="View and Edit Existing"
              onClick={onShowViewWarehouseModal}
            />
          </Panel>
        </StyledRowItem>
      </StyledRow>
      <StyledRow>
        <StyledRowItem>
          <Panel
            icon={<PackageIcon />}
            header="Package Details"
            minHeight={minPanelHeight + 30}
          >
            <PackageWrapper>
              <PackageUsage>
                Current package:
                <PackageInfo>
                  {capitalizeFirstLetter(packageDetails?.name)}
                </PackageInfo>
              </PackageUsage>
              <PackageUsage>
                Users:
                <PackageInfo>
                  {users?.count} / {users?.package_total}
                </PackageInfo>
              </PackageUsage>
              <PackageUsage>
                Warehouses:
                <PackageInfo>
                  {warehouses?.count} / {warehouses?.package_total}
                </PackageInfo>
              </PackageUsage>
              <PackageUsage>
                Storages:
                <PackageInfo>
                  {storages?.count} / {storages?.package_total}
                </PackageInfo>
              </PackageUsage>
              <PackageUsage>
                Inventory Items:
                <PackageInfo>
                  {inventory?.count} / {inventory?.package_total}
                </PackageInfo>
              </PackageUsage>
              <PackageUsage>
                Inventory Assets:
                <PackageInfo>
                  {assets?.count} / {assets?.package_total}
                </PackageInfo>
              </PackageUsage>
            </PackageWrapper>
          </Panel>
        </StyledRowItem>
        <StyledRowItem>
          <Panel
            header="Inventory"
            icon={<InventoryIcon />}
            minHeight={minPanelHeight}
          >
            <LinkButton
              onClick={onShowCategoryModal}
              caption="View and Edit Categories"
            />
            <LinkButton
              caption="View and Edit Tags"
              onClick={onShowTagModal.bind(null, INVENTORY)}
            />
          </Panel>
        </StyledRowItem>
      </StyledRow>
      <StyledRow>
        <StyledRowItem>
          <Panel
            header="Billing"
            icon={<BillingIcon />}
            minHeight={minPanelHeight}
          >
            <LinkButton onClick={console.log} caption="View Billing History" />
            <LinkButton
              onClick={console.log}
              caption="Change Billing Details"
            />
          </Panel>
        </StyledRowItem>
        <StyledRowItem>
          <Panel
            header="Order"
            icon={<ActivityIcon />}
            minHeight={minPanelHeight}
          >
            <LinkButton
              caption="View and Edit Tags"
              onClick={onShowTagModal.bind(null, ORDER)}
            />
            <LinkButton
              caption="Set default terms and conditions"
              onClick={onShowSettingModal.bind(null, ORDER_SETTING)}
            />
          </Panel>
        </StyledRowItem>
      </StyledRow>
      <StyledRow>
        <StyledRowItem>
          <Panel
            header="Storages"
            icon={<WarehouseIcon />}
            minHeight={minPanelHeight}
          >
            <LinkButton onClick={onShowAddStorageModal} caption="Add New" />
            <LinkButton
              caption="View and Edit Existing"
              onClick={onShowViewStorageModal}
            />
          </Panel>
        </StyledRowItem>
        <StyledRowItem>
          <Panel
            header="Notifications"
            icon={<ActivityIcon />}
            minHeight={minPanelHeight}
          >
            <LinkButton
              caption="Email"
              onClick={onShowSettingModal.bind(
                null,
                EMAIL_NOTIFICATION_SETTING,
              )}
            />
          </Panel>
        </StyledRowItem>
      </StyledRow>
    </StyledWrapper>
  );
}

Settings.propTypes = {
  onShowTagModal: func,
  onShowCompanyModal: func,
  onShowCategoryModal: func,
  onShowAddStorageModal: func,
  onShowViewStorageModal: func,
  onShowAddWarehouseModal: func,
  onShowViewWarehouseModal: func,
};
